import React from 'react';
import './style.scss';
import useCheckNewVersionAvailable from '../../Utils/UseCheckNewVersionAvailable';
import DefaultTooltip from '../../Utils/DefaultTooltip';

interface UnreadBadgeProps {
  unreadCount?: number;
  unreadText?: string;
  squished?: boolean;
  style?: React.CSSProperties;
  className?: string;
  backgroundColor?: string;
  showFullCount?: boolean;
}

const UnreadBadge: React.FC<UnreadBadgeProps> = ({
  unreadCount,
  unreadText,
  squished,
  style = {},
  className = '',
  backgroundColor,
  showFullCount = false,
}) => {
  const badgeStyle = backgroundColor ? { ...style, backgroundColor } : style;

  return (
    <>
      {unreadCount !== undefined && unreadCount >= 1 && (
        <div
          className={`unread-badge ${squished ? 'squished' : ''} ${className}`}
          style={badgeStyle}
        >
          <span key={unreadCount}>
            {!showFullCount && unreadCount >= 100 ? '99+' : unreadCount}
          </span>
        </div>
      )}
      {!!unreadText && (
        <div
          className={`unread-badge ${squished ? 'squished' : ''} ${className}`}
          style={badgeStyle}
        >
          <span key={unreadText}>{unreadText}</span>
        </div>
      )}
    </>
  );
};

export const UpdateBadge = ({ children }: { children: React.ReactNode }) => {
  const newVersion = useCheckNewVersionAvailable();
  return (
    <div className="update-badge-holder relative">
      {newVersion && (
        <DefaultTooltip title="There's a new version available. Refresh for the latest updates">
          <div className="unread-badge absolute right-0">!</div>
        </DefaultTooltip>
      )}
      {children}
    </div>
  );
};

export default UnreadBadge;
